import React from "react";
import { MdDelete } from "react-icons/md";
import FullPageLoader from "../Loader/FullPageLoader";
import { Button } from "../CustomComponent";
import { Spinner } from "react-bootstrap";

const DeleteModal = ({ setIsOpen, modalData, onRemoveClick, isLoading }) => {
  const handleCancel = () => {
    setIsOpen(false);
  };
  return (
    <>
      <div className="logout-modal-content">
        <div className="d-flex justify-content-center align-content-center">
          <MdDelete color="red" size={55} className="mb-3" />
        </div>
        <div className="w-100 text-center">
          <h2>Delete</h2>
          <p>Are you sure you want to Delete?</p>
        </div>
        <div className="w-100">
          <Button classes="cancel-btn w-100 text-white" onClick={handleCancel} text="Cancel" />  
          <Button classes="cancel-btn w-100 text-white mt-3" onClick={onRemoveClick} text={isLoading ? <Spinner /> : "Remove"} disabled={isLoading} />  
        </div>
      </div>
    </>
  );
};

export default DeleteModal;
